import { render, staticRenderFns } from "./65.vue?vue&type=template&id=c2cb483c&scoped=true&"
var script = {}
import style0 from "./65.vue?vue&type=style&index=0&id=c2cb483c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cb483c",
  null
  
)

export default component.exports